import React from 'react';
import { Body, Icon, IconType, Theme } from '@routific/hive';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  onUnassignClick: () => void;
  disabled?: boolean;
  driverName: string;
}

const StyledDiv = styled.div<{ disabled?: boolean }>`
  margin: 0;
  width: 100%;
  padding: ${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing} ${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing};
  display: flex;
  align-items: center;
  user-select: none;
  color: ${Theme.Colors.primary5};
  overflow: hidden;
  .ant-typography-body {
    color: ${Theme.Colors.primary5};
  }
  gap: 12px;

  ${({ disabled }) => (disabled ? `
    opacity: 0.6;
    cursor: not-allowed;
  ` : `
    :hover {
      background: ${Theme.Colors.primary2};
      cursor: pointer;
    }
    :active {
      background: ${Theme.Colors.primary3};
    }
  `)}
`;

const UnassignDriver: React.FC<Props> = ({ onUnassignClick, disabled = false, driverName }) => {
  const { t } = useTranslation('components');

  const handleClick = () => {
    if (!disabled) {
      onUnassignClick();
    }
  };

  return (
    <StyledDiv
      data-testid="unassign-driver"
      onClick={handleClick}
      disabled={disabled}
    >
      <Icon icon={IconType.Remove} size="medium" type="accent" style={{ flexShrink: 0 }} />
      <Body ellipsis>{t('assignDriver.labels.unassignDriver', { driverName })}</Body>
    </StyledDiv>
  );
};

export default UnassignDriver;
